/* 47X · FAM47 · Login estilo Instagram para el área de atletas.
   Reemplaza la contraseña diaria. Usuario+contraseña propios, sesión persistente (token en localStorage).
   Habla con el Worker vía App Proxy: /apps/atletas/auth/(register|login). Gated a miembros FAM47.
   Se carga ANTES de dashboard-fam47.js y expone window.FAM47_TOKEN para que apiCall lo mande. */
(function () {
  'use strict';
  var TOKEN_KEY = 'fam47:token';
  var ACCESO_URL = 'https://47x100pre.com/products/acceso-renacer-fam47';

  function getToken() { try { return localStorage.getItem(TOKEN_KEY) || ''; } catch (e) { return ''; } }
  function setToken(t) { try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch (e) {} window.FAM47_TOKEN = t || ''; }
  window.FAM47_TOKEN = getToken();
  try { if (/[?&](logout|salir)=1/.test(location.search)) setToken(''); } catch (e) {}
  window.FAM47_LOGOUT = function () { setToken(''); location.reload(); };

  var ERRORS = {
    no_eres_fam47: 'Este correo no está en la FAM47. ¿Ya tienes tu acceso?',
    correo_invalido: 'Escribe un correo válido',
    usuario_invalido: 'Usuario: 3-20 letras, números, punto o guion bajo',
    password_corta: 'La contraseña necesita al menos 6 caracteres',
    usuario_ocupado: 'Ese usuario ya existe, elige otro',
    correo_ya_registrado: 'Ese correo ya tiene cuenta. Inicia sesión',
    usuario_o_password: 'Usuario o contraseña incorrectos',
    codigo_invalido: 'El código de hoy no es correcto · pídelo en el grupo',
    codigo_requerido: 'Hoy se pide el código de acceso · pídelo en el grupo',
    credenciales_invalidas: 'Faltan datos',
    server_error: 'Error del servidor, intenta de nuevo',
    invalid_signature: 'Sesión inválida, recarga la página',
    missing_signature: 'Recarga la página'
  };

  function api(endpoint, payload) {
    return fetch('/apps/atletas/' + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return { ok: false, error: 'server_error' }; }); });
  }

  var CSS = '\
  .figauth{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:22px;\
    background:radial-gradient(ellipse at 50% 0%,rgba(0,255,102,.10),transparent 55%),#050608;font-family:Jost,system-ui,-apple-system,sans-serif;}\
  .figauth__card{width:100%;max-width:360px;background:linear-gradient(180deg,#0c0e11,#08090b);border:1px solid rgba(0,255,102,.18);\
    border-radius:16px;padding:30px 24px;box-shadow:0 30px 80px -20px rgba(0,0,0,.8);}\
  .figauth__logo{font-family:"Archivo Black",Jost,sans-serif;font-size:26px;letter-spacing:.04em;color:#fff;text-align:center;margin:0 0 4px;}\
  .figauth__logo b{color:#39FF14;}\
  .figauth__sub{text-align:center;color:#8a8f98;font-size:12.5px;margin:0 0 22px;letter-spacing:.02em;}\
  .figauth__field{margin-bottom:12px;}\
  .figauth__field input{width:100%;box-sizing:border-box;background:#111318;border:1px solid rgba(255,255,255,.12);border-radius:10px;\
    color:#eef0f2;font-size:15px;padding:13px 14px;outline:none;font-family:inherit;}\
  .figauth__field input:focus{border-color:#39FF14;box-shadow:0 0 0 2px rgba(0,255,102,.18);}\
  .figauth__btn{width:100%;border:none;border-radius:10px;padding:13px;font-family:"Archivo Black",Jost,sans-serif;font-size:14px;\
    letter-spacing:.04em;text-transform:uppercase;color:#04120a;background:linear-gradient(145deg,#7dff8f,#39FF14 60%,#1fbf3a);\
    cursor:pointer;margin-top:6px;transition:transform .12s,filter .12s;}\
  .figauth__btn:disabled{opacity:.6;cursor:default;}\
  .figauth__btn:active{transform:scale(.98);}\
  .figauth__msg{min-height:16px;font-size:12.5px;text-align:center;margin:10px 0 2px;color:#ff6b6b;line-height:1.35;}\
  .figauth__msg--ok{color:#39FF14;}\
  .figauth__switch{text-align:center;margin-top:16px;font-size:13px;color:#8a8f98;}\
  .figauth__switch a{color:#39FF14;text-decoration:none;font-weight:600;cursor:pointer;}\
  .figauth__hint{display:block;text-align:center;margin-top:14px;font-size:11.5px;color:#5f636b;}\
  .figauth__hint a{color:#8a8f98;}\
  .figauth__foot{text-align:center;margin-top:18px;font-size:10.5px;letter-spacing:.14em;color:#3f434a;text-transform:uppercase;}\
  [data-fam47-gate]{display:none !important;visibility:hidden !important;}';

  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }

  function mount() {
    var style = document.createElement('style'); style.textContent = CSS; document.head.appendChild(style);
    try { var og = document.querySelectorAll('[data-fam47-gate]'); for (var i=0;i<og.length;i++){ og[i].hidden = true; og[i].style.display='none'; } } catch(e){}
    var wrap = el('<div class="figauth" role="dialog" aria-label="Acceso FAM47"></div>');
    var card = el('<div class="figauth__card"></div>');
    card.appendChild(el('<h1 class="figauth__logo">FAM<b>47</b></h1>'));
    var sub = el('<p class="figauth__sub"></p>');
    var form = el('<form autocomplete="on"></form>');
    var fUser = el('<div class="figauth__field"><input name="username" type="text" autocomplete="username" placeholder="Usuario" autocapitalize="none" spellcheck="false"></div>');
    var fEmail = el('<div class="figauth__field"><input name="email" type="email" autocomplete="email" placeholder="Correo de tu acceso" autocapitalize="none" spellcheck="false"></div>');
    var fPass = el('<div class="figauth__field"><input name="password" type="password" autocomplete="current-password" placeholder="Contraseña"></div>');
    var fCode = el('<div class="figauth__field"><input name="code" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="Código de hoy (6 dígitos)"></div>');
    var btn = el('<button class="figauth__btn" type="submit"></button>');
    var msg = el('<div class="figauth__msg"></div>');
    var sw = el('<div class="figauth__switch"></div>');
    var hint = el('<span class="figauth__hint"></span>');
    form.appendChild(fUser); form.appendChild(fEmail); form.appendChild(fPass); form.appendChild(fCode);
    form.appendChild(btn); form.appendChild(msg);
    card.appendChild(sub); card.appendChild(form); card.appendChild(sw); card.appendChild(hint);
    card.appendChild(el('<div class="figauth__foot">Ecosistema 47X100PRE</div>'));
    wrap.appendChild(card); document.body.appendChild(wrap);

    var mode = 'login', forceCode = false;
    function render() {
      if (mode === 'login') {
        sub.textContent = 'Entra a tu ecosistema';
        fEmail.style.display = 'none';
        fCode.style.display = forceCode ? '' : 'none';
        fPass.querySelector('input').setAttribute('autocomplete', 'current-password');
        btn.textContent = 'Entrar';
        sw.innerHTML = '¿Primera vez? <a data-go="register">Crea tu cuenta</a>';
        hint.innerHTML = '';
      } else {
        sub.textContent = 'Crea tu cuenta · solo miembros FAM47';
        fEmail.style.display = '';
        fCode.style.display = '';
        fPass.querySelector('input').setAttribute('autocomplete', 'new-password');
        btn.textContent = 'Crear cuenta';
        sw.innerHTML = '¿Ya tienes cuenta? <a data-go="login">Inicia sesión</a>';
        hint.innerHTML = 'Usa el correo con el que compraste tu acceso · <a href="' + ACCESO_URL + '">¿Aún no lo tienes?</a>';
      }
      msg.textContent = ''; msg.className = 'figauth__msg';
    }
    sw.addEventListener('click', function (e) {
      var g = e.target.getAttribute('data-go'); if (!g) return;
      e.preventDefault(); mode = g; render();
    });
    render();

    function success(token) {
      setToken(token);
      msg.className = 'figauth__msg figauth__msg--ok'; msg.textContent = 'Listo, entrando…';
      setTimeout(function () { location.reload(); }, 350);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var username = form.username.value.trim();
      var password = form.password.value;
      msg.className = 'figauth__msg'; msg.textContent = '';
      btn.disabled = true; btn.textContent = mode === 'login' ? 'Entrando…' : 'Creando…';
      var p, ep;
      var codeVal = form.code.value.trim();
      if (mode === 'login') { ep = 'auth/login'; p = { username: username, password: password }; if (forceCode) p.code = codeVal; }
      else { ep = 'auth/register'; p = { username: username, password: password, email: form.email.value.trim(), code: codeVal }; }
      api(ep, p).then(function (r) {
        btn.disabled = false; render();
        if (r && r.ok && r.token) return success(r.token);
        var code = (r && r.error) || 'server_error';
        msg.textContent = ERRORS[code] || 'No se pudo, intenta de nuevo';
        if (code === 'correo_ya_registrado') { mode = 'login'; render(); msg.textContent = ERRORS[code]; }
        if (code === 'codigo_requerido') { forceCode = true; render(); msg.textContent = ERRORS[code]; }
      }).catch(function () { btn.disabled = false; render(); msg.textContent = ERRORS.server_error; });
    });
  }

  // Sin token → login. Con token → validar; si la sesión ya no vale (revocada/expirada), cerrar y mostrar login.
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.FAM47_TOKEN) { mount(); return; }
    fetch('/apps/atletas/auth/me?atleta_token=' + encodeURIComponent(window.FAM47_TOKEN))
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) { if (!d || !d.ok) { setToken(''); mount(); } })
      .catch(function () {});
  });
})();
